import React from 'react';
import moment from 'moment-business-days';
import {
	Col,
	Grid,
	Label,
	ListGroupItem,
	Row
} from 'react-bootstrap';

import './Request.css';

const Request = (props) => {
	const { dateRequested, duration, editable, empFirstName, empLastName, dueDate } = props;
	const approved = props["approved?"]

	const workDays = duration / 28800 - 1;

	return <ListGroupItem>
		<Grid style={{width: "inherit"}}>
			<Row bsClass="row row-flex">
				<Col md={3} className="hours">
					<h2 className="duration">{duration / 3600}</h2>
					<p>hours</p>
				</Col>
				<Col md={6} style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: "center"}}>
					{editable ? <h4><Label bsSize="lg">{empLastName[0]}, {empFirstName[0]}</Label></h4> : null}
					<p>Start Date: {moment(dateRequested).format('MM/DD/YYYY')}</p>
					<p>End Date: {moment(dateRequested).businessAdd(workDays).format('MM/DD/YYYY')}</p>
				</Col>
				<Col md={3} style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', textAlign: 'center', alignItems: 'center'}}>
					{dueDate ? <Label bsStyle="danger">Due: {dueDate.format('MM/DD/YYYY')}</Label> : null}
					<div
						className={approved ? "checkmark" : "exed"}
						{...(editable ? {onClick: () => props.editRequest(props.id, !approved), style: {cursor: "pointer"}} : {})}
					>
					</div>
				</Col>
			</Row>
		</Grid>
	</ListGroupItem>
}

export default Request;


// WEBPACK FOOTER //
// ./src/components/Request/Request.js